module.exports = __webpack_public_path__ + "static/media/regimen-weight.f6e9d36d.svg";